/* eslint-disable import/no-extraneous-dependencies */
import React, {useRef, useEffect, useState} from 'react';
import styled from 'styled-components';
import {useSize} from 'ahooks';

const StyledContent = styled.div`
${({cardNum, imageHeight}) => `
& {
  .category-card {
    .category-card-item {
      width: calc((100% - ${20 * (cardNum - 1)}px) / ${cardNum}) !important;
      .category-card-item-image-wrapper {
        height: ${!imageHeight ? 'unset' : `${imageHeight}px`};
      }
    }
  }
}
`}
`;

const Content = ({configData}) => {
  const listRef = useRef(null);
  const containerSize = useSize(listRef);
  const [cardNum, setCardNum] = useState(4);
  const [imageHeight, setImageHeight] = useState(0);
  useEffect(() => {
    if (containerSize && containerSize.width) {
      if (containerSize.width >= 1620 && containerSize.width < 1940) {
        setCardNum(5);
        setImageHeight(((containerSize.width - 80) / 5) * 0.5625);
      }
      if (containerSize.width >= 1298 && containerSize.width < 1620) {
        setCardNum(4);
        setImageHeight(((containerSize.width - 60) / 4) * 0.5625);
      }
      if (containerSize.width >= 980 && containerSize.width < 1298) {
        setCardNum(3);
        setImageHeight(((containerSize.width - 40) / 3) * 0.5625);
      }
      if (containerSize.width >= 660 && containerSize.width < 980) {
        setCardNum(2);
        setImageHeight(((containerSize.width - 20) / 2) * 0.5625);
      }
      // 1： 320 * 1 = 320px
      // 2： 320 * 2 + 20 = 660px
      // 3： 320 * 3 + 40 = 1000px
      // 4： 320 * 4 + 60 = 1340px
      // 5： 320 * 5 + 80 = 1680px
      // 6： 320 * 6 + 100 = 2020px

      // 1： 280 * 1 + 60 = 340px
      // 2： 280 * 2 + 40 + 60 = 660px
      // 3： 280 * 3 + 80 + 60 = 980px
      // 4： 280 * 4 + 120 + 60 = 1300px
      // 5： 280 * 5 + 160 + 60 = 1620px
      // 6： 280 * 6 + 200 + 60 = 1940px
    }
  }, [containerSize]);

  return (
    <div className='content'>
      <StyledContent ref={listRef} cardNum={cardNum} imageHeight={imageHeight}>
        {
          configData.map((category, index) => (
            <div className='category'>
              <div className='category-header'>
                <div className='category-header-order'>
                  <div className='category-header-order-back' />
                  <div className='category-header-order-num'>{index + 1}</div>
                </div>
                <span className='category-header-category'>{category.category}</span>
              </div>
              <div className='category-card'>
                {category.item.map((card) => (
                  <div className='category-card-item' onClick={() => window.open(card.url)}>
                    <div className='category-card-item-image-wrapper'>
                      <img alt='' className='category-card-item-image' src={require(`~/${card.image}`)} />
                      <div className='cover-opacity' />
                    </div>
                    <div className='category-card-item-content'>
                      <div className='category-card-item-content-name'>{card.name}</div>
                      <div div className='category-card-item-content-description'>{card.description}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        }
      </StyledContent>
    </div>
  );
};

export default Content;
